export const debugOnlyCall = {
  apply: (target, thisArg, argumentsList) => {
    if (process.env.NODE_ENV === 'development') {
      target(...argumentsList)
    }
  },
}

export default debugOnlyCall
